import type { User } from '../types';

/**
 * Can this user reach /billing?
 *
 * Mirrors the route guard in BillingPage and requireRole(['admin','billing'])
 * on the API. Anything that renders an "Upgrade plan" link MUST gate on this,
 * so a link can never point somewhere the route rejects.
 */
export function canAccessBilling(user: User | undefined | null): boolean {
  return user?.role === 'admin' || user?.role === 'billing';
}
